import {useModel} from './use_model.js';
import {insertModelFeedback} from './insert_model_feedback.js';

const useModelFeedback = function(){
    return insertModelFeedback(useModel(...arguments));
}

export {useModelFeedback};